<template>
    <b-modal
        :id="keyName"
        :ref="keyName"
        :title="title"
        :ok-disabled="disabled"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        size="lg"
        modal-class="apprentice-default-modal rating-modal">
        <div class="ratings-type">
            <div class="row">
                <div class="col-12 col-sm-4 rating-option">
                    <div
                        class="rating-disabled apprentice-simple-card"
                        :class="type === 0 && 'active'">
                        <div class="rating-disabled-icon icon">
                            <i class="far fa-ban btn btn-primary-icon-only"></i>
                        </div>
                        <div class="rating-disabled-content content">
                            <h6 class="title">{{ $t('portfolio.no_review') }}</h6>
                            <div class="description">
                                {{ $t('portfolio.disable_rating') }}
                            </div>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="type = 0"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 rating-option">
                    <div
                        class="rating-ovg-option apprentice-simple-card"
                        :class="type === 1 && 'active'">
                        <div class="rating-ovg-option-icon icon">
                            <i class="far fa-text btn btn-primary-icon-only"></i>
                        </div>
                        <div class="rating-ovg-option-content content">
                            <h6 class="title">OVG</h6>
                            <div class="description">
                                {{ $t('portfolio.set_review_based_on_OVG') }}
                        </div>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="type = 1"></a>
                    </div>
                </div>

                <div class="col-12 col-sm-4 rating-option">
                    <div
                        class="rating-grade-option apprentice-simple-card"
                        :class="type === 2 && 'active'">
                        <div class="rating-grade-option-icon icon">
                            <i class="far fa-sort-numeric-up-alt btn btn-primary-icon-only"></i>
                        </div>
                        <div class="rating-grade-option-content content">
                            <h6 class="title">{{ $t('portfolio.grade') }}</h6>
                            <div class="description">
                                {{ $t('portfolio.review_based_on_grade') }}
                            </div>
                        </div>
                        <a
                            class="clickable"
                            href="#"
                            @click="type = 2"></a>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="connections"
            v-if="connections">
            <b-form-group
                :label="$t('portfolio.implement_for')"
                label-for="portfolio-rating-connections-checkboxes">
                <b-form-checkbox-group
                    class="apprentice-checkbox connection-group"
                    id="portfolio-rating-connections-checkboxes"
                    v-model="selectedConnectionOptions"
                    :options="connections"
                    value-field="type"
                    text-field="name"
                    disabled-field="notEnabled">
                </b-form-checkbox-group>
            </b-form-group>
        </div>

        <div
            class="rating-options"
            v-if="type === 1">
            <label>{{ $t('portfolio.ovg_options') }}</label>
            <draggable
                handle=".fa-th"
                :list="ovg_options"
                ghost-class="drag-ghost">
                <div
                    class="ovg-rating-option"
                    v-for="(option, i) in ovg_options"
                    :key="i">
                    <div class="drag-icon">
                        <i class="fas fa-fw fa-arrows-alt-v"></i>
                    </div>
                    <b-input-group class="ovg-rating-option-input-group">
                        <b-form-input v-model="option.value"></b-form-input>
                        <b-input-group-append>
                            <b-button
                                class="btn-remove btn-remove-rating-option"
                                variant="danger-icon"
                                @click="removeOvgOption(i)">
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </draggable>

            <div class="add-rating-ovg-option">
                <b-button
                    class="btn-add btn-add-option"
                    variant="primary"
                    @click="addOvgOption">
                    {{ $t('portfolio.new_type') }}
                </b-button>
            </div>
        </div>

        <div
            class="grade-rating"
            v-if="type === 2 && showGradeOptions">
            <label>{{ titleWeight }}</label>

            <div
                class="grade-rating-warning"
                v-if="!grade_options.length">
                <b-alert
                    show
                    variant="warning">
                    {{
                        $t(
                            'portfolio.when_there_are_ratings_of_the_type_grade_on_x_you_can_determine_the_weighting_of_the_grades_here',
                            { name: childName },
                        )
                    }}
                </b-alert>
            </div>

            <div
                class="grade-rating-weight-options"
                v-else>
                <div
                    class="grade-rating-weight-option"
                    v-for="(option, i) in grade_options"
                    :key="i">
                    <div class="grade-rating-weight-name">
                        <span style="line-height: 2">{{ option.name }}</span>
                        <b-form-input
                            v-model="option.value"
                            type="number"></b-form-input>
                    </div>
                </div>

                <b-alert
                    show
                    variant="warning">
                    {{
                        $t(
                            'portfolio.the_weighting_can_be_ignored_if_the_grade_is_calculated_itself_or_if_all_components_have_the_same_weighting',
                        )
                    }}
                </b-alert>
            </div>
        </div>
    </b-modal>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-portfolio-edit-rating-modal-component',
    components: { draggable },
    props: [
        'objectIn',
        'gradeTarget',
        'keyName',
        'showGradeOptions',
        'gradeType',
        'connections',
        'title',
        'titleWeight',
    ],
    data() {
        return {
            object: this.objectIn,
            type:
                this.objectIn.portfolio_rating && this.objectIn.portfolio_rating.type
                        ? this.objectIn.portfolio_rating.type
                        : 0,
            ovg_options:
                this.objectIn.portfolio_rating && this.objectIn.portfolio_rating.options.length
                    ? this.objectIn.portfolio_rating.options
                    : [
                          { id: null, value: this.$t('portfolio.fail'), order: 1 },
                          { id: null, value: this.$t('portfolio.pass'), order: 2 },
                          { id: null, value: this.$t('portfolio.good'), order: 3 },
                      ],
            grade_options: !this.showGradeOptions
                ? []
                : this.objectIn[this.gradeTarget]
                      .filter((item) => item.portfolio_rating && item.portfolio_rating.type === 2)
                      .map((item) => {
                          return {
                              id: item.id,
                              name: item.name,
                              value:
                                  item.portfolio_rating && item.portfolio_rating.weight !== null
                                      ? item.portfolio_rating.weight
                                      : 1,
                          };
                      }),
            selectedConnectionOptions: [],
            connectionTargetIsSelected: false,
        };
    },
    watch: {
        objectIn(value) {
            this.object = value;
            this.type =
                this.objectIn.portfolio_rating && this.objectIn.portfolio_rating.type
                        ? this.objectIn.portfolio_rating.type
                        : 0;

            this.ovg_options =
                this.objectIn.portfolio_rating && this.objectIn.portfolio_rating.options.length
                    ? this.objectIn.portfolio_rating.options
                    : [
                          { id: null, value: this.$t('portfolio.fail'), order: 1 },
                          { id: null, value: this.$t('portfolio.pass'), order: 2 },
                          { id: null, value: this.$t('portfolio.good'), order: 3 },
                      ];

            this.grade_options = !this.showGradeOptions
                ? []
                : value[this.gradeTarget]
                      .filter(
                          (item) =>
                              this.connectionTargetIsSelected ||
                              (item.portfolio_rating && item.portfolio_rating.type === 2),
                      )
                      .map((item) => {
                          return {
                              id: item.id,
                              name: item.name,
                              value:
                                  item.portfolio_rating && item.portfolio_rating.weight !== null
                                      ? item.portfolio_rating.weight
                                      : 1,
                          };
                      });
        },
        selectedConnectionOptions(options) {
            for (const option of options) {
                if (option === this.gradeType) {
                    this.connectionTargetIsSelected = true;
                    return;
                }
            }
            this.connectionTargetIsSelected = false;
        },
        connectionTargetIsSelected(bool) {
            this.grade_options = !this.showGradeOptions
                ? []
                : this.object[this.gradeTarget]
                      .filter((item) => bool || (item.portfolio_rating && item.portfolio_rating.type === 2))
                      .map((item) => {
                          return {
                              id: item.id,
                              name: item.name,
                              value:
                                  item.portfolio_rating && item.portfolio_rating.weight !== null
                                      ? item.portfolio_rating.weight
                                      : 1,
                          };
                      });
        },
    },
    methods: {
        addOvgOption() {
            this.ovg_options.push({ id: null, name: '', order: this.ovg_options.length + 1 });
        },
        removeOvgOption(index) {
            let array = [];

            for (let x = 0; x < this.ovg_options.length; x++) {
                if (x === index) {
                    continue;
                }
                array.push(this.ovg_options[x]);
            }

            this.ovg_options = array;
        },
        onOk() {
            const data = {
                id: this.object.id,
                type: this.type,
                ovg_items: this.ovg_options,
                grade_items: this.grade_options,
                connections: this.selectedConnectionOptions.map((i) => {
                    return { type: i };
                }),
            };
            this.$emit('on-save', data);
        },
    },
    computed: {
        disabled() {
            return false;
        },
        childName() {
            for (const option of this.connections) {
                if (option.type === this.gradeType) {
                    return option.name.toLowerCase();
                }
            }
            return '';
        },
    },
};
</script>

<style scoped lang="scss">
.ratings-type {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .rating-option {
        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        }
    }
}

.rating-disabled,
.rating-ovg-option,
.rating-grade-option {
    height: 100%;
    position: relative;
    background-color: $secondary-background-color;
    border: 2px solid transparent;

    .icon {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        i {
            display: flex;
            align-content: center;
            justify-content: center;
            line-height: 1;
            text-align: center;
            font-size: 4rem;
        }
    }

    .content {
        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            font-weight: $font-weight-bold;
        }

        .description {
            color: $text-muted-color;
        }
    }

    &.active {
            border: 2px solid var(--primary);
    }

    &:hover {
        cursor: pointer;
        box-shadow: 1px 0px 4px $border-color;
            border: 2px solid var(--primary);

        .icon {
            i {
                    color: var(--primaryLightest);
            }
        }
    }
}

.connection-group:hover {
    cursor: default;
}

.connection-group:hover ::v-deep span {
    font-weight: $font-weight-normal;
}

.connections {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .connection-group ::v-deep {
        .custom-checkbox {
            &:first-child,
            &:nth-child(2) {
                label {
                    min-width: 85px;
                }
            }

            &:nth-child(3) {
                label {
                    min-width: 115px;
                }
            }
        }

        label {
            &:hover {
                span {
                    font-weight: $font-weight-bold;
                }
            }
        }
    }
}

.ovg-rating-option {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 10px;

    .drag-icon {
        align-self: center;
        cursor: pointer;
        line-height: 2;
            color: var(--primary);

        &:hover {
            color: $text-color;
        }
    }

    .btn-remove-rating-option {
        border-top-right-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
        padding-right: map-get($grid-gutter-spacing, 'ten');

        &:before,
        &:after {
            align-self: center;
        }
    }
}

.add-rating-ovg-option {
    display: flex;
    justify-content: flex-start;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.grade-rating {
    .grade-rating-weight-name {
        span {
            font-weight: $font-weight-bold;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .ratings-type {
        .rating-option {
            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }

    .add-rating-ovg-option {
        .btn {
            width: auto;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .ovg-rating-option {
        max-width: 450px;
    }
}
</style>
